import React from 'react';
import './App.css';
import Home from './Home';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import '../node_modules/bootstrap-icons/font/bootstrap-icons.json';
import '../node_modules/bootstrap-icons/bootstrap-icons.svg';

import { Link, Routes, Route } from "react-router-dom";
import STUDIOS from './Studio';
import Team from './Team';
import Servic from './Servic';
import Work from './Work';
import Contact from './Contact';


function App() {
  return (
    <>


      <div className='continer'>

        <nav className="navbar navbar-expand-lg bg-body-white">
          <div className="container-fluid">
            <a className="navbar-brand fw-bold fs-2 ps-md-5" href="#"><span className='Main-heading-in-nav'>CRYSTAL</span></a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                <li className="nav-item">

                  <Link to="/" className='nav-link active fw-bold p-2 '><span className='Main-heading-in-nav'>HOME</span></Link>

                </li>
                <li className="nav-item">

                  <Link to="/STUDIOS" className='nav-link active fw-bold p-2'><span className='nav-words'>STUDIOS</span></Link>

                </li>

                <li className="nav-item">

                  <Link to="/TEAM" className='nav-link active fw-bold p-2'><span className='nav-words'>TEAM</span></Link>

                </li>
                <li className="nav-item">


                  <Link to="/SERVIC" className='nav-link active fw-bold p-2'><span className='nav-words'>SERVICE</span></Link>


                </li>

                <li className="nav-item">

                  <Link to="/WORK" className='nav-link active fw-bold p-2'><span className='nav-words'>WORK</span></Link>

                </li>
                <li className="nav-item">

                  <Link to="/CONTACT" className='nav-link active fw-bold p-2'><span className='nav-words'>CONTACT</span></Link>

                </li>
              </ul>
            </div>
          </div>
        </nav>

      </div>


      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/STUDIOS' element={<STUDIOS />} />
        <Route path='/Team' element={<Team />} />
        <Route path='/Servic' element={<Servic />} />
        <Route path='/Work' element={<Work />} />
        <Route path='/Contact' element={<Contact />}/>
      </Routes>

    </>
  )
}

export default App;
